export default "__VITE_ASSET__C7h9kl0u__"